import { render, staticRenderFns } from "./CursoAWS.vue?vue&type=template&id=59150116&scoped=true"
import script from "./CursoAWS.vue?vue&type=script&lang=js"
export * from "./CursoAWS.vue?vue&type=script&lang=js"
import style0 from "./CursoAWS.vue?vue&type=style&index=0&id=59150116&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59150116",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/CursoAWS.vue
// module id = kUU2
// module chunks = 41